export const aavsoLightCurve = `timestamp,magnitude
1684582049000,13.385333333333335
1684625249000,11.972410256410257
1684668449000,11.845833333333333
1684711649000,11.330348314606741
1684754849000,11.309210280373833
1684798049000,11.121178125
1684841249000,11.101986301369863
1684884449000,11.12956610878661
1684927649000,11.098957446808509
1684970849000,11.043252688172043
1685014049000,11.054695652173914
1685057249000,11.063711814345991
1685100449000,11.082699999999999
1685143649000,11.082035862068965
1685186849000,11.116285714285713
1685230049000,11.09607655172414
1685273249000,11.128023529411765
1685316449000,11.09654761904762
1685359649000,11.151816091954023
1685402849000,11.098493506493506
1685446049000,11.095949999999`;